import { connect } from 'react-redux';

import { selectWindspeedReadings } from './selectors';
import Windspeed from './Windspeed.component';

const mapStateToProps = (state) => ({
  sensors: selectWindspeedReadings(state),
})

export default connect(
  mapStateToProps,
)(Windspeed)


// WEBPACK FOOTER //
// ./src/plots/Windspeed/Windspeed.container.js